/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-24 10:33:30
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Icon, Heading, Grid, Button, Link, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FieldArray } from 'redux-form';
import { ExternalSmallMinor } from '@shopify/polaris-icons';

import RuleBasedList from './rule-based-list';
import AiBasedAlgorithm from './ai-based-algorithm';
// import BannerWarning from 'src/components/views/recommendation/widget/item/banner-warning';
import { URL } from 'src/constants/links';
import FlatIcon from 'src/assets/images/subscription-v4/star.svg';

import {
  RECOMMENDATION_AI_BASED_FBT_PRIMARY_OPTIONS,
  RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES
} from 'src/constants/recommendation';

type Props = WithI18nProps & {
  formValues: RecommendationWidgetType,
  updateField: Function,
  host: string,
  aimlPermission: boolean,
  syncOrderStatus: {},
  AIBasedRecommendProduct: string
};

class FrequentlyBoughtTogether extends Component<Props> {
  render() {
    const {
      i18n,
      formValues,
      updateField,
      // syncOrderStatus,
      aimlPermission,
      AIBasedRecommendProduct,
      secondaryAlgorithm
    } = this.props;
    const activeRuleBased = _.get(formValues, 'activeRuleBased', false) && aimlPermission;
    const activeAIBased = _.get(formValues, 'activeAIBased', false) && aimlPermission;
    const ruleBasedList = _.get(formValues, 'ruleBasedList', []);
    // const showSyncBanner = aimlPermission && syncOrderStatus.status === 'running';
    // const disabledAI = syncOrderStatus.status !== 'done' || !aimlPermission;

    return (
      <div className="widget-based-section">
        <div className="general-items">
          <Heading>
            {i18n.translate('AdminHTML.Recommendation.WidgetItem.widgetBasedSection_Label')}
          </Heading>
          <Grid>
            <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <div className={`button-large ${activeAIBased ? 'isSelected' : ''}`}>
                <Button
                  fullWidth
                  onClick={() => this.changeValue('activeAIBased')}
                  disabled={!aimlPermission}>
                  <div className="btn-title btn-title-type">
                    <div className="btn-title-content">
                      {i18n.translate('AdminHTML.Recommendation.WidgetItem.activeAIBased_Label')}
                    </div>
                    <div className="btn-title-icon">
                      <img width={22} height={22} src={FlatIcon} alt="wand" />
                    </div>
                  </div>
                  <div className="btn-content">
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetItem.activeAIBased_Description'
                    )}
                  </div>
                </Button>
              </div>
            </Grid.Cell>
            <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <div className={`button-large ${activeRuleBased ? 'isSelected' : ''}`}>
                <Button
                  fullWidth
                  onClick={() => this.changeValue('activeRuleBased')}
                  disabled={!aimlPermission}>
                  <div className="btn-title">
                    <div className="btn-title-content">
                      {i18n.translate('AdminHTML.Recommendation.WidgetItem.activeRuleBased_Label')}
                    </div>
                  </div>
                  <div className="btn-content">
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetItem.activeRuleBased_Description'
                    )}
                  </div>
                </Button>
              </div>
            </Grid.Cell>
          </Grid>
          {/* show banner when synchronizing */}
          {/* {showSyncBanner && (
            <div className="widget-based-warning-banner">
              <BannerWarning
                contents={[
                  i18n.translate(
                    `AdminHTML.Recommendation.AIModelBannerProcessing.widgetContent_all`
                  )
                ]}
              />
            </div>
          )} */}
        </div>
        {activeAIBased && (
          <div className="general-items">
            <Heading>
              {i18n.translate(
                'AdminHTML.Recommendation.WidgetItem.widgetAIBasedMethodSection_Label',
                {
                  index: i18n.translate(
                    'AdminHTML.Recommendation.WidgetItem.widgetAIBasedMethodSection_Label_Index'
                  )
                }
              )}
            </Heading>
            <div className="widget-details-block">
              <AiBasedAlgorithm
                updateField={updateField}
                type={
                  RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES['frequently-bought-together'].value
                }
                primaryDisabled={true}
                primaryOptions={RECOMMENDATION_AI_BASED_FBT_PRIMARY_OPTIONS}
                primaryAlgorithm={AIBasedRecommendProduct}
                secondaryAlgorithm={secondaryAlgorithm}
              />
            </div>
          </div>
        )}
        {activeRuleBased && (
          <div className="general-items">
            <Heading>
              {i18n.translate(
                'AdminHTML.Recommendation.WidgetItem.widgetRuleBasedMethodSection_Label'
              )}
            </Heading>
            <div className="widget-details-block">
              <p>
                <TextStyle>
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetItem.widgetRuleBasedMethodSection_Description',
                    {
                      t1: (
                        <Link external url={URL['RecommendationRuleBasedLearnmore']}>
                          {i18n.translate('AdminHTML.Common.Action.learnMore')}
                          <Icon source={ExternalSmallMinor} color={'interactive'}></Icon>
                        </Link>
                      )
                    }
                  )}
                </TextStyle>
              </p>
              <FieldArray
                name="ruleBasedList"
                component={RuleBasedList}
                ruleBasedList={ruleBasedList}
                updateField={updateField}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  changeValue = (newValue: string) => {
    const { updateField } = this.props;
    updateField('activeRuleBased', newValue === 'activeRuleBased');
    updateField('activeAIBased', newValue === 'activeAIBased');
  };
}

export default withI18n()(FrequentlyBoughtTogether);
